import React, { useState } from "react";
import styled from "styled-components";

const DropDownList = styled("ul")``;
const ListItem = styled("li")``;

const options = window.__litium.constants.languages;
const selectedLanguage = window.__litium.constants.selectedLanguage;

export default function CountryPicker() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  return (
    <div className="country-picker__select">
      <div
        className={
          isOpen ? "country-picker__current active" : "country-picker__current"
        }
        onClick={toggling}
      >
        <span className="country-picker__selected">
          {selectedOption || selectedLanguage}
        </span>
        <i className="sicon-chevron-down"></i>
      </div>
      {isOpen && (
        <DropDownList className="country-picker__options">
          {options.map((option) => (
            <ListItem
              onClick={onOptionClicked(option.label)}
              key={Math.random()}
              className="country-picker__option"
            >
              <a href={option.value}>{option.text}</a>
            </ListItem>
          ))}
        </DropDownList>
      )}
    </div>
  );
}
